<div class="modal fade" id="uploadDocumentsModal" tabindex="-1" role="dialog"
  aria-labelledby="uploadDocumentsModalLabel" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ heading }}</h4>

        <button class="close" type="button">
          <img src="./assets/icons/close.svg" alt="Close" (click)="fnCloseUploadModal()" />
        </button>
      </div>

      <div class="modal-body position-relative px-0">
        <div class="px-3">
          <alert></alert>
        </div>
        @if(isSampleExcelVisible){
          <div class="right-align">
            <span class="highlight sample" (click)="fnDownloadSample()">
              Download XLSX sample
            </span>
          </div>
        }

        <div class="content p-3 py-0">
          <div class="dropzone" appDnd (fileDropped)="onFileDropped($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
              <g fill="#3B454F" fill-rule="nonzero">
                <path
                  d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                <path
                  d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                <path
                  d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
              </g>
            </svg>
            <input class="cursor-pointer" type="file" #fileDropRef single name="file" id="fileDropRef"
              (change)="fileBrowseHandler($event)" onclick="this.value=null;" title="Browse for Files" accept=".xlsx" />

            <h3>Drag and Drop files here</h3>
            <h3>or</h3>

            <label for="fileDropRef">Browse for Files</label>
          </div>
          @if(showNote){
            <div class="mandatory-note">
              <p>* {{ footerNote }}</p>
            </div>
          }

          <div class="files-list">
            @for(item of file; track item?.name){
              <ng-container>
                <div class="single-file">
                  <div class="info">
                    <h4 class="name">{{ item?.name }}</h4>
  
                    <p class="size">
                      {{ formatBytes(item?.size, 2) }}
                    </p>
  
                    @if(file){
                      <p class="text-danger">
                        {{ errorMessage }}
                      </p>
                    }
                  </div>
  
                  <div class="delete" (click)="deleteFile()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                      <path fill="#B1B1B1" fill-rule="nonzero"
                        d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                    </svg>
                  </div>
                </div>
              </ng-container>
            }
          </div>
        </div>

        <div class="button-cont">
          <button class="btn btn-cancel" type="button" (click)="fnCloseUploadModal()">
            Cancel
          </button>

          <button class="btn btn-primary" type="button" (click)="fnOnSubmit()"
            [disabled]="!this.file[0]?.name || this.disableUpload">
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>
</div>